<template>
  <div class="control_box" v-dialogDrag>
    <div class="Control_popover">
      <div class="control_title">
        指令下发 <span @click="closeControlpopover">×</span>
      </div>
      <div class="control_inner">
        <!-- 下拉菜单 -->
        <div class="control_inner_left">
          <ul class="one_stair_menu">
            <!-- 一级菜单 -->
            <li v-for="(item, index) in menudata" :key="index">
              <p :class="item.active == false ? 'menu_bottom_border' : ''" @click="oneSelectClick(item)">
                <span>
                  <i class="iconfont" :class="item.icon"></i>
                  <span :title="item.name">{{ item.name }}</span>
                </span>
                <i :class=" item.active == false? 'el-icon-caret-top': 'el-icon-caret-bottom'"></i>
              </p>
              <!-- 二级菜单 -->
              <ul v-show="item.active">
                <li
                    v-for="(item1, index1) in item.value"
                    :key="index1"
                    @click="twoSelectClick(item1)"
                    :class="item1.twoSelect ? 'selectItem' : ''"
                    :title="item1.name">
                  <i class="el-icon-position"></i> {{ item1.name }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="control_inner_right">
          <!-- 设备状态信息 -->
          <div class="status" v-for="(item, index) in statusIfo" :key="index">
            <div>
              <span>{{ item.ptdControlName }}{{ item.feedbackUnit }}</span>
              <span v-if="item.feedbackSign == 0" :title="item.feePointTableStatesName">{{
                  item.feePointTableStatesName
                }}</span>
            </div>
            <div>
              <!-- 下拉框 -->
              <div class="select" v-show="item.controlInputForm == 2">
                <div>
                  <el-select v-model="item.selectValue">
                    <el-option v-for="item2 in item.pointTableStates"
                               :key="item2.stateCode"
                               :label="item2.stateName"
                               :value="item2.stateCode">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- 输入框 -->
              <div class="select" v-show="item.controlInputForm == 0">
                <div>
                  <el-input
                      type="number"
                      placeholder="请输入内容"
                      class="input"
                      v-model="item.inputValue"></el-input>
                </div>
                <span style="color: red" v-show="item.regSign">*</span>
                <span :title="item.explainText" v-if="item.feedbackSign == 0">{{ item.explainText }}</span>
              </div>
              <!-- 按钮 -->
              <div class="select" v-show="item.controlInputForm == 1">
                <div v-for="(btn1, i1) in item.pointTableStates" :key="i1">
                  <button @click="btnClick(item, btn1.stateCode)">{{ btn1.stateName }}</button>
                </div>
                <span :title="item.explainText">{{ item.explainText }}</span>
              </div>
            </div>

          </div>
          <!-- 实时动态数据 -->
          <div class="dynamic_box">
            <div class="dynamic_item" v-for="(item1, index1) in devData" :key="index1">
              <div class="dynamic_left">
                <span :title="item1.ptdControlName">{{ item1.ptdControlName }}{{ item1.feedbackUnit }}</span>
                <span :title="item1.feePointTableStatesName"
                      v-if="item1.feedbackSign == 0">{{ item1.feePointTableStatesName }}</span>
              </div>
              <div class="dynamic_right">
                <!-- 下拉框 -->
                <div class="select" v-show="item1.controlInputForm == 2">
                  <div>
                    <el-select v-model="item1.selectValue" placeholder="启动方式选择">
                      <el-option
                          v-for="item2 in item1.pointTableStates"
                          :key="item2.stateCode"
                          :label="item2.stateName"
                          :value="item2.stateCode"></el-option>
                    </el-select>
                  </div>
                  <span>
                    <el-popover class="item" effect="light" width="30" placement="bottom" trigger="click">
                       <div v-html="item1.explainText"></div>
                       <span slot="reference" title="点我查看全部" class="el-icon-info"
                             v-if="item1.explainText !== ''"></span>
                    </el-popover>
                    <span :title="item1.explainText">{{ item1.explainText }}</span>
                  </span>
                </div>
                <!-- 输入框 -->
                <div class="select" v-show="item1.controlInputForm == 0">
                  <div>
                    <el-input
                        type="number"
                        placeholder="请输入内容"
                        class="input"
                        v-model="item1.inputValue"></el-input>
                  </div>
                  <span style="color: red" v-show="item1.regSign">*</span>
                  <span>
                    <el-popover class="item" effect="light" width="30" placement="bottom" trigger="click">
                       <div v-html="item1.explainText"></div>
                       <span slot="reference" title="点我查看全部" class="el-icon-info"
                             v-if="item1.explainText !== ''"></span>
                    </el-popover>
                    <span :title="item1.explainText">{{ item1.explainText }}</span>
                  </span>
                </div>
                <!-- 按钮 -->
                <div class="select" v-show="item1.controlInputForm == 1">
                  <div v-for="(btn1, i1) in item1.pointTableStates" :key="i1">
                    <button @click="btnClick(item1, btn1.stateCode)">{{ btn1.stateName }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 最小边下发指令按钮 -->
          <div class="bottom_btn">
            <button @click="senbOrderClick">下发指令</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 下发指令弹窗 -->
    <el-dialog
        title="指令下发"
        :visible.sync="verifyDialog"
        top="20%"
        @close="cloDialogClick"
        :append-to-body="true"
        :lock-scroll="false"
        class="dialog_box">
      <div class="content">
        <div v-for="(item, index) in submitValue" :key="index">
          <span> {{ item.ptdControlName }} :</span>
          <span v-show="textShow">
              <span v-for="(item1, index1) in item.pointTableStates" :key="index1" v-show="item.inputValue == ''">
                <span v-show="item1.stateCode == item.selectValue">{{ item1.stateName }}</span>
              </span>
            <span v-show="!item.inputValue == ''"> {{ item.inputValue }}</span>
          </span>
          <span v-show="btnShow">
              <span v-for="(item1, index1) in item.pointTableStates" :key="index1" v-show="item.inputValue == ''">
                <span v-show="item1.stateCode == item.stateCode">{{ item1.stateName }}</span>
              </span>
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="verifyDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import myApi from "../../util/my-api";
import myConst from "../../util/my-const";
import fun from "../../util/util";
import mqttClient from 'mqtt/dist/mqtt'
import topic from "@/assets/js/iems/topic"

export default {
  data() {
    return {
      menudata: [], //菜单信息
      devData: [], //设备数据
      statusIfo: [], //截取返回的状态信息渲染页面
      devId: "", //设备id
      devCode: "", //设备码
      statId: "", //电站id
      stationCode: "", //电站码
      timerId: null,  //定时器
      submitValue: [], //提交的内容,用来展示在确认下发指令弹出框
      submitArr: [], //提交后台的参数
      verifyDialog: false, //下发指令确认弹出框的状态
      textShow: false, //下发指令确认框输入框和下拉框提交内容显示状态
      btnShow: false, //下发指令确认框按钮提交内容显示状态
      dataLoadWay: "", //实时数据加载方式
      client: null, //mqtt对象
      options: { //mqtt配置信息
        connectTimeout: "", // 超时时间
        username: "", //账户
        password: "", //密码
        clientId: "", //客户端id
        path: "",
      },
      prefix: "", //mqtt主题前缀
      mqttUrl: '',//mqtt连接地址
      refreshTime: 5000, //实时数据刷新间隔
    };
  },
  computed: {
    ...mapState("controlPopover", ["showControlNew", "id",'devTypeList']),
  },

  methods: {
    ...mapMutations("controlPopover", ["openControl", "closeControl"]),
    // 一级菜单(设备类型)点击事件
    oneSelectClick(item) {
      item.active = !item.active;
    },

    // 二级菜单(设备)点击事件
    twoSelectClick(item) {
      this.menudata.forEach((item) => {
        item.value.forEach((sonItem) => {
          sonItem.twoSelect = false;
        });
      });
      item.twoSelect = true;
      this.devId = item.id;
      this.devCode = item.value
      this.getDevInfo().then(() => {
        if (this.dataLoadWay === myConst.dataLoadWay.real) {//如果当前数据加载方式是实时通讯
          this.MqttTopic()
        }
      }).catch(() => {
      })

    },

    //关闭控制窗按钮
    closeControlpopover() {
      this.closeControl();
    },

    //加载电站静态信息
    loadStationInfo() {
      let _this = this;
      return new Promise((resolve, reject) => {
        this.$axios.get(myApi.getBusGetOne + "?id=" + this.statId).then(res => {
          if (res.data.code === myConst.code.success) {
            _this.sysName = res.data.data.stationName;
            this.dataLoadWay = res.data.data.dataLoadWay  //实时数据加载方式
            this.refreshTime = res.data.data.refreshInterval * 1000 //间隔时间
            this.stationCode = res.data.data.stationCode  //电站码
            resolve()
          } else {
            _this.sysName = "";
            reject()
          }
        }).catch(() => {
        });
      })
    },

    // 加载mqtt配置信息
    loadMqttConfigInfo() {
      return new Promise((resolve, reject) => {
        this.$axios.get(myApi.getMqttConnInfo).then(res => {
          if (res.data.code === myConst.code.success) {
            // mqtt连接地址ip
            let ip = res.data.data.filter(item => {
              return item.infoCode == 'ip'
            })[0].infoTag

            //mqtt连接地址端口
            let port = res.data.data.filter(item => {
              return item.infoCode == 'port'
            })[0].infoTag

            //mqtt连接地址拼接后缀
            let path = res.data.data.filter(item => {
              return item.infoCode == 'path'
            })[0].infoTag

            //mqtt客户端id前缀字符串
            let idPrefix = res.data.data.filter(item => {
              return item.infoCode == 'idPrefix'
            })[0].infoTag

            // mqtt账号
            let account = res.data.data.filter(item => {
              return item.infoCode == 'account'
            })[0].infoTag

            //mqtt密码
            let password = res.data.data.filter(item => {
              return item.infoCode == 'password'
            })[0].infoTag

            //mqtt连接超时时间
            let connTimeout = res.data.data.filter(item => {
              return item.infoCode == 'connTimeout'
            })[0].infoTag

            // mqtt连接地址协议
            let connPrefix = res.data.data.filter(item => {
              return item.infoCode == 'connPrefix'
            })[0].infoTag
            // console.log(connPrefix,ip,port);
            // 获取mqtt的配置信息
            this.options = {
              connectTimeout: connTimeout, // 超时时间
              username: account, //账户
              password: password, //密码
              clientId: idPrefix + Math.random().toString(16).substring(2, 8), //客户端id
              path: path,
            }
            this.mqttUrl = connPrefix + ip + ":" + port
            resolve()
          } else {
            this.options = {}
            this.mqttUrl = ""
            reject()
          }
        }).catch(() => {
        })
      })
    },

    //获取mqtt主题前缀
    loadTopicDevRtd() {
      return new Promise((resolve, reject) => {
        this.$axios.get(myApi.getTopicDevRtd).then(res => {
          if (res.data.code === myConst.code.success) {
            this.prefix = res.data.data.infoTag
            resolve()
          } else {
            reject()
          }
        })
      })
    },

    //实时数据加载方式判断逻辑
    realDataChange() {
      this.loadStationInfo().then(() => {
        if (this.dataLoadWay === myConst.dataLoadWay.real) { //如果电站静态信息的实时数据加载方式是实时通讯(mqtt)
          this.loadMqttConfigInfo().then(() => {
            this.client = mqttClient(this.mqttUrl, this.options) //创建mqtt连接
          })
        } else {//如果电站静态信息的实时数据加载方式是扫描历史数据表
          this.timerId = window.setInterval(this.updateTime, this.refreshTime);
        }
      }).catch(() => {

      })
    },

    // mqtt订阅主题
    MqttTopic() {
      this.loadTopicDevRtd().then(() => {
        if (fun.isNull(this.devId)) {
          return
        } else {
          let tioic = topic.dev(this.prefix, this.stationCode, this.devCode)
          if (fun.isObjNotNull(this.upTopic)) {
            this.client.unsubscribe(this.upTopic);
          }
          this.client.subscribe(tioic, {qos: 0}, (error) => {
            if (error) {
              console.log("订阅失败", error);
            } else {
              this.upTopic = tioic;
              console.log("订阅成功");
            }
          })
          // 监听信息，topic：收到信息的主题；message：收到的数据
          this.client.on("message", (topic, message) => {
            // 收到信息后，执行回调
            this.mqttMsg(topic, message);
            return;
          })

        }
      }).catch(() => {
      })
    },

    //mqtt回调函数
    mqttMsg(tioic, msg) {
      const decoder = new TextDecoder();
      const jsonString = decoder.decode(msg);
      this.disposeData(JSON.parse(jsonString))
    },

    //获取设备数据点
    getDevInfo() {
      this.statusIfo = []
          this.devData = []
      let params = {
        stationId: this.statId,
        devId: this.devId,
      };
      return new Promise((resolve, reject) => {
        this.$axios.get(myApi.getDevDataPoint, {params}).then((res) => {
          if (res.data.code === myConst.code.success) {
            let devArr = res.data.data;
            devArr.forEach((item) => {
              item.ptdControlKeyName = fun.isNull(item.ptdControlKeyName) ? '' : item.ptdControlKeyName; //根据key加载的名字
                  item.selectValue = -2; //下拉框选择的内容
                  item.inputValue = ""; //输入框选择的内容
                  item.regSign = false; //正则校验标识
              item.feedbackUnit = fun.isNull(item.feedbackUnit) ? '' : '(' + item.feedbackUnit + ')'
              item.feePointTableStatesName = ""
              if (item.controlInputForm == myConst.controlInputForm.select) {
                //给下拉框第一个增加一个默认选项,-2表示没有选择状态
                item.pointTableStates.unshift({
                  stateCode: -2,
                  stateName: item.ptdControlName + "选择!",
                });
              }
            });
            let status = devArr.splice(0, 1); //截取第一行数据
            this.statusIfo = status;
            this.devData = devArr; //数组截取会改变原数组,直接将截取后的数组进行赋值操作
            this.updateTime()
            resolve()
          } else {
            reject()
            // this.$message({message: res.data.msg, type: "info"})
          }
        });
      })
    },

    //按钮点击事件
    btnClick(keyObj, code) {
      this.btnShow = true;
      this.verifyDialog = true;
      keyObj.stateCode = code;
      this.submitValue.push(keyObj);
      this.submitArr.push({
        key: keyObj.ptdControlKey,
        value: code,
      });
    },

    //下发指令方法
    sendOrder() {
      let data = {
        staId: this.statId,
        devId: this.devId,
        data: this.submitArr,
      };
      this.$axios.post(myApi.sendInstructNew, data).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.$message({message: res.data.msg, type: "success"});
          this.verifyDialog = false;
          this.submitArr = [];
          this.submitValue = [];
          this.loadHisData()
          this.devData.forEach(item => {
            if (item.controlInputForm == myConst.controlInputForm.text) {
              item.inputValue = ''
            } else if (item.controlInputForm == myConst.controlInputForm.select) {
              item.selectValue = -2
            }
          })
          this.statusIfo.forEach(item => {
            if (item.controlInputForm == myConst.controlInputForm.text) {
              item.inputValue = ''
            } else if (item.controlInputForm == myConst.controlInputForm.select) {
              item.selectValue = -2
            }
          })
        } else {
          this.verifyDialog = false;
          // this.$message({message: res.data.msg, type: "info",});
        }
      });
    },

    //有没有传入设备id的执行逻辑
    isDevId() {
      if (fun.isNull(this.devId)) { //如果没有传入设备id,则默认显示第一个
        let defauleId = this.menudata[0].value[0].id;
        this.menudata[0].active = true;
        this.menudata[0].value[0].twoSelect = true;
        this.devId = defauleId;
        this.devCode = this.menudata[0].value[0].value
        this.getDevInfo().then(() => {
          if (this.dataLoadWay === myConst.dataLoadWay.real) {//如果当前数据加载方式是实时通讯
            this.MqttTopic()
          }
        }).catch(() => {
        })

      } else {
        //如果传入了设备id 则根据id请求设备接口渲染右侧信息
        this.menudata.forEach((item) => {
          //从当前电站的设备列表中找出传入的设备id,让其默认选中
          item.value.find((sonItem) => {
            if (sonItem.id === this.devId) {
              item.active = true;
              sonItem.twoSelect = true;
              this.devCode = sonItem.value;
              this.getDevInfo().then(() => {
                if (this.dataLoadWay === myConst.dataLoadWay.real) {//如果当前数据加载方式是实时通讯
                  this.MqttTopic()
                }
              }).catch(() => {
              })
            }
          });
        });
      }
    },

    // 定时器调用方法
    updateTime() {
      if (fun.isNull(this.devId)) {
        return
      } else {
        this.loadHisData()
      }
    },

    //通讯扫描历史表加载数据
    loadHisData() {
      this.$axios.get(myApi.getDevRealTimeData + "?devId=" + this.devId).then(res => {
        if (res.data.code === myConst.code.success) {
          this.disposeData(JSON.parse(res.data.data))
        } else {
        }
      }).catch(() => {
      });
    },

    //处理返回的实时数据进行显示
    disposeData(msg) {
      let realData = new Map() //创建一个map集合
      msg.data.forEach(item => {
        realData.set(item.pId, item) //向map集合添加数据
      })
      this.statusIfo.forEach(item => {
        if (item.feePointTableStates.length > 0) {
          if (realData.has(item.ptdFeedbackKey)) {
            item.feePointTableStates.forEach(x => {
              if (!fun.isNull(realData.get(item.ptdFeedbackKey))) {
                if (x.stateCode == realData.get(item.ptdFeedbackKey).val) {
                  item.feePointTableStatesName = x.stateName
                  realData.delete(item.ptdFeedbackKey)
                }
              }
            })
          }
        } else {
          if (realData.has(item.ptdFeedbackKey)) {
            item.feePointTableStatesName = realData.get(item.ptdFeedbackKey).val
            realData.delete(item.ptdFeedbackKey)
          }
        }
      })
      this.devData.forEach(item => {
        if (item.feePointTableStates.length > 0) {
          if (realData.has(item.ptdFeedbackKey)) {
            item.feePointTableStates.forEach(x => {
              if (!fun.isNull(realData.get(item.ptdFeedbackKey))) {
                if (x.stateCode == realData.get(item.ptdFeedbackKey).val) {
                  item.feePointTableStatesName = x.stateName
                }
              }
            })
          }
        } else {
          if (realData.has(item.ptdFeedbackKey)) {
            item.feePointTableStatesName = realData.get(item.ptdFeedbackKey).val
            realData.delete(item.ptdFeedbackKey)
          }
        }
      })
    },

    //检验下发指令提交内容的工具方法
    validUntil(arr) {
      arr.forEach((item, index) => {
        if (item.controlInputForm == myConst.controlInputForm.text) {
          arr[index].controlSubmit = true; //针对文本框项增加校验是否通过的属性
          if (item.inputValue.length > 0) {
            // item.regExpText=fun.isNull(item.regExpText)?'^(0|[1-9]\d{0,2})(\.\d+)?$':item.regExpText
            if (fun.isNull(item.regExpText)) {
              this.submitArr.push({
                key: item.ptdControlKey,
                value: item.inputValue,
              });
              this.submitValue.push(item);
              //校验通过将当前项的正则检验标识取消
              arr[index].regSign = false;
              //检验通过将当前 校验通过 属性变成true
              arr[index].controlSubmit = true;
            } else {
              const regex = new RegExp(item.regExpText.toString());
              if (regex.test(item.inputValue)) {
                //校验通过,将key和输入框内容添加到数组中
                this.submitArr.push({
                  key: item.ptdControlKey,
                  value: item.inputValue,
                });
                this.submitValue.push(item);
                //校验通过将当前项的正则检验标识取消
                arr[index].regSign = false;
                //检验通过将当前 校验通过 属性变成true
                arr[index].controlSubmit = true;
              } else {
                //将下拉框选中内容添加到数组中,即使检验的值错误也不会提交后台,重新按下提交按钮会将数组清空
                this.submitArr.push({
                  key: item.ptdControlKey,
                  value: item.inputValue,
                });
                //校验不通过将当前正则检验标识显示
                arr[index].regSign = true;
                //校验不通过将当前  检验通过  属性变成false
                arr[index].controlSubmit = false;
              }
            }

          }
        } else if (item.controlInputForm == myConst.controlInputForm.select) {
          //如果下拉框选中的值小于0,则表示该项没有选择内容
          if (item.selectValue < 0) {
            return;
          } else {
            this.submitArr.push({
              key: item.ptdControlKey,
              value: item.selectValue,
            });
            this.submitValue.push(item);
          }
        }
      })
    },

    // 下发指令按钮
    senbOrderClick() {
      this.textShow = true;
      this.submitValue = [];
      this.submitArr = [];
      this.validUntil(this.statusIfo)
      this.validUntil(this.devData)
      //获取输入框每一项
      let restData = this.devData.filter((item) => {
        if (!fun.isNull(item.inputValue)) {
          return item.controlInputForm == myConst.controlInputForm.text;
        }
      });
      let oneData = this.statusIfo.filter(item => {
        if (!fun.isNull(item.inputValue)) {
          return item.controlInputForm == myConst.controlInputForm.text;
        }
      })
      let inputData = [...restData, ...oneData]
      //检查输入框项是否全部通过校验规则
      let valid = inputData.every((e) => {
        return e.controlSubmit;
      });
      //如果没有选择下发命令
      if (this.submitArr.length < 1) {
        this.$message({
          message: "请选择命令!",
          type: "info",
        });
      } else if (valid && this.submitArr.length > 0) {
        this.verifyDialog = true;
      } else if (!valid) {
        //如果输入框校验的值没通过
        this.$message({message: "请在输入框填写0-400的数值", type: "info",});
      }
    },

    // 提交弹窗内容
    submitClick() {
      this.sendOrder();
    },

    //关闭弹窗清除数据
    cloDialogClick() {
      this.submitValue = [];
      this.submitArr = [];
      this.textShow = false; //输入框和下拉框文本显示状态
      this.btnShow = false; //状态按钮文本显示状态
    },

    //断开mqtt连接
    offMqtt() {
      if (!fun.isNull(this.client)) {
        this.client.end();
      }
    }

  },

  mounted() {
    this.statId = this.id.stationId;
    this.devId = this.id.devId;
    this.menudata =  this.devTypeList     
      this.isDevId();  //执行是否传入设备id的逻辑 
    this.realDataChange()
  },

  //页面销毁清除定时器
  beforeDestroy() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
    }
    if (this.dataLoadWay === myConst.dataLoadWay.real) {
      this.offMqtt() //页面销毁,断开mqtt连接
    }

  },
};
</script>

<style scoped>
::v-deep .el-dialog {
  width: 24%;
  height: auto;
  background-image: none;
  background-color: #fff;
}

::v-deep .el-dialog__headerbtn {
  top: 1rem;
}

.content {
  width: 100%;
  min-height: 2rem;
  max-height: 25rem;
  overflow: auto;
  /* background-color: hotpink; */
}

.content > div {
  padding: 0.8rem;
  margin-left: 3rem;

}

.control_box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  /* background-color: rgba(0, 0, 0, 0.8); */
}

.Control_popover {
  width: 135rem;
  height: 80rem;
  position: relative;
  left: 50%;
  margin-left: -67.5rem;
  top: 50%;
  margin-top: -40rem;
  background: url("../../assets/images/iems/control_win_bag.png") no-repeat center/100%;
  overflow: hidden;
  box-sizing: border-box;
  font-size: 1.4rem;
}

.control_title {
  padding-top: 0.7rem;
  height: 5.5%;
  width: 100%;
  color: #000f21;
  font-size: 1.8rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  position: relative;
}

.control_title > span {
  position: absolute;
  display: flex;
  right: 1.5%;
  width: 1.4rem;
  height: 1.4rem;
  font-size: 2.2rem;
  color: #00dafc;
  cursor: pointer;
}

.control_inner {
  width: 100%;
  height: 94.5%;
  /* background-color: hotpink; */
  padding: 1% 1% 2% 1%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

/* 左边菜单 */
.control_inner_left {
  width: 23%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  color: #fff;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  padding: 0 0 1rem 0;
  box-sizing: border-box;
}

.control_inner_left > .one_stair_menu {
  overflow: auto;
  font-weight: 600;
}

.control_inner_left > .one_stair_menu > li {
  margin-bottom: 1rem;
}

/* 一级菜单标题 */
.control_inner_left > .one_stair_menu > li > p {
  padding-left: 2.9rem;
  padding: 1rem 0rem 1rem 2.9rem;
  box-sizing: border-box;
  width: 100%;
  height: 6%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #071d30;
  border-top: 1px solid #005469;
  border-left: 1px solid #005469;
  border-right: 1px solid #005469;
  cursor: pointer;
}

.control_inner_left > .one_stair_menu > li > p > span {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}

.control_inner_left > .one_stair_menu > li > p i:nth-child(1) {
  display: inline-block;
  margin-right: 1rem;
}

.control_inner_left > .one_stair_menu > li > p i:nth-child(2) {
  padding-right: 2rem;
  box-sizing: border-box;
  color: #00dafc;
}

.menu_bottom_border {
  border-bottom: 1px solid #005469;
}

/* 二级菜单 */
.control_inner_left > .one_stair_menu > li > ul {
  width: 100%;
  padding-left: 4.6rem;
  box-sizing: border-box;
  border-bottom: 1px solid #005469;
  border-left: 1px solid #005469;
  border-right: 1px solid #005469;
  background-color: #071d30;
}

.selectItem {
  color: #00dafc;
}

.control_inner_left > .one_stair_menu > li > ul > li {
  width: 100%;
  height: 3.5rem;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  line-height: 4rem;

}

.control_inner_left > .one_stair_menu > li > ul > li:last-child {
  margin-bottom: 1rem;
}

.control_inner_left > .one_stair_menu > li > ul > li:hover {
  color: #00dafc;
}

/* 右边详情 */
.control_inner_right {
  height: 100%;
  width: 76%;
  background-color: #0a1930;
  border: 1px solid #0386a2;
  padding: 1%;
  box-sizing: border-box;
}

.dynamic {
  width: 100%;
  height: 88%;
  /* background-color: hotpink; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 最上边运行状态 */
.status {
  width: 100%;
  height: 10%;
  border-bottom: 0.2rem solid #005469;
  display: flex;
  position: relative;
}

.status > div:nth-child(1) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 37%;
  height: 100%;
  margin-left: 1rem;
}

.status > div:nth-child(2) {
  display: flex;
  align-items: center;
  width: 55%;
  height: 100%;
  position: absolute;
  right: 0;
}

.status > div:nth-child(1) > span:nth-child(1) {
  width: 50%;
  margin-left: 1rem;
  font-size: 1.4rem;
  font-weight: 400;
  color: #fff;

}

.status > div:nth-child(1) > span:nth-child(2) {
  width: 50%;
  font-size: 1.4rem;
  font-weight: 400;
  color: #00dafc;
  text-align: center;
}

.iconfont {
  margin-right: 0.5rem;
}

/* .status > div:nth-child(2) > div {
  width: 8rem;
  height: 3.4rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 400;
  color: #00dafc;
  cursor: pointer;
  margin-right: 1rem;
  background: url(../../assets/images/one_menu_bag.png) no-repeat center/100%
    100%;
} */
/* .status > div:nth-child(2) > div:hover {
  background: url(../../assets/images/one_menu_bag_sel.png) no-repeat
    center/100% 100%;
  color: #fde223;
} */
/* 中间部分 */
.dynamic_box {
  width: 100%;
  height: 79%;
  margin-top: 1.5rem;
  overflow: auto;
}

.dynamic_item {
  width: 100%;
  height: 4.5rem;
  margin-bottom: 1rem;
  background-color: #0a223a;
  display: flex;
  align-items: center;
  position: relative;
}

.dynamic_item > .dynamic_left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 35%;
  height: 100%;
  height: 100%;
  margin-left: 2rem;
}

.dynamic_left > span:nth-child(1) {
  width: 47%;
  font-size: 1.4rem;
  font-weight: 400;
  color: #fff;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}

.dynamic_left > span:nth-child(2) {
  font-size: 1.4rem;
  font-weight: 400;
  color: #00dafc;
  width: 50%;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}

.dynamic_right {
  height: 100%;
  width: 55%;
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
}

/* 输入框样式 */
.select {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.select > span {
  font-weight: 400;
  color: #00dafc;
  font-size: 1.2rem;
  font-family: PingFangSC;
  margin-left: 1rem;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}

.input {
  width: 20rem;
}

/* 按钮样式 */
.select > div > button {
  min-width: 5rem;
  width: auto;
  height: 3rem;
  background-image: url(../../assets/images/iems/control_btn.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-size: 1.4rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #0bc4f0;
  cursor: pointer;
  margin-right: 2rem;
  padding: 0 0.5rem;
  box-sizing: border-box;
}

.select > div > button:hover {
  background-image: url(../../assets/images/iems/control_btn_hove.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fde223;
}

.select > div > button.switch {
  background-image: url(../../assets/images/iems/control_btn_hove.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fde223;
}

/* 最下边下发指令按钮 */
.bottom_btn {
  width: 100%;
  height: 12%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom_btn > button {
  width: 12.2rem;
  height: 4rem;
  background-image: url(../../assets/images/iems/but_bat_1.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-size: 1.4rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  /* position: absolute;
  right: 27%; */
}

.bottom_btn > button:hover {
  background-image: url(../../assets/images/iems/but_bat_1_hove.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fde223;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

::v-deep .el-button {
  border: none;
}

.el-icon-info {
  margin-right: 1rem;
  cursor: pointer;
  font-size: 1.5rem;
}

.tool_content {
  width: 18rem;
}
</style>
